import { createApp } from "vue"
import App from "./App.vue"

// npm install vue-router@4
import router from "@/router/index"

// Vuex
import store from '@/store'

// npm install --save apexcharts
// npm install --save vue3-apexcharts
import VueApexCharts from "vue3-apexcharts";

// npm install @mdi/font -D
import '@mdi/font/css/materialdesignicons.css'

// main.css
import '../src/assets/css/main.css'

// npm install vuetify
import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'

const customQuickSoftTheme = {
  dark: true,
  colors: {
    background: "#B38BAB",
    surface: "#15202b",
    primary: "#3f51b5",
    secondary: "#03dac6",
    error: "#f44336",
    info: "#2196F3",
    success: "#4caf50",
    warning: "#fb8c00",
  },
};

const vuetify = createVuetify({
  components,
  directives,
  icons: {
    defaultSet: 'mdi', // This is already the default value - only for display purposes
  },
  theme: {
    defaultTheme: "light",
    themes: {
      customQuickSoftTheme,
    },
  },
})

createApp(App).use(router).use(store).use(vuetify).use(VueApexCharts).mount('#app')
